module.exports = __webpack_public_path__ + "img/zev-education@3x.034e66b1.webp";